import { render, staticRenderFns } from "./GoodsForm3.vue?vue&type=template&id=41aabd68&scoped=true"
import script from "./GoodsForm3.vue?vue&type=script&lang=js"
export * from "./GoodsForm3.vue?vue&type=script&lang=js"
import style0 from "./GoodsForm3.vue?vue&type=style&index=0&id=41aabd68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aabd68",
  null
  
)

export default component.exports